






































































import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination.vue';
import { emailApis, EmailSummery } from '@/api/email.api';
import { formatterDatetime } from '@/common';

@Component({ components: { Pagination } })
export default class MailUndoPage extends Vue {
  readonly twiceConfirmText = '我要撤回';

  query = '';
  loading = false;
  items: EmailSummery[] = [];
  formatterDatetime = formatterDatetime;
  dialogVisible = false;
  selectedEmail: EmailSummery | null = null;
  confirmText = '';
  undoLoading = false;
  result = {
    items: [] as EmailSummery[],
    total: 0,
    tips: ''
  };

  async mounted() {
    await this.getItemList();
  }

  async getItemList() {
    this.loading = true;
    try {
      const resp = await emailApis.listAllowUndoEmails();
      this.result = resp;
    } catch (error) {
      console.error('Failed to fetch undo emails:', error);
    } finally {
      this.loading = false;
    }
  }

  confirmUndo(email: EmailSummery) {
    this.selectedEmail = email;
    this.dialogVisible = true;
  }

  resetDialog() {
    this.confirmText = '';
    this.selectedEmail = null;
  }

  async handleUndo() {
    if (this.confirmText !== this.twiceConfirmText) {
      this.$message.warning(`请输入"${this.twiceConfirmText}"以确认撤回`);
      return;
    }
    if (!this.selectedEmail) return;

    this.undoLoading = true;
    try {
      await emailApis.undoEmail(this.selectedEmail?.id);
      this.$message.success('邮件撤回请求已发送，请注意查收邮件回执');
      this.dialogVisible = false;
      await this.getItemList();
    } catch (error) {
      console.error('Failed to undo email:', error);
      this.$message.error(error.message || '撤回邮件失败，请重试');
    } finally {
      this.undoLoading = false;
    }
  }
}
